import React from 'react';

import classes from '../installPics.css';

import Image from '../../../../../../../assets/FlatBallastedImg1.jpg';

const Pic
 = () => (
     <div className={classes.installImages}>
         <img alt="Flat Ballasted Array" src={Image} className={classes.installImg} />
     </div>
 );


export default Pic;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/FlatBallasted/FlatBallastedImg1.js